export const REEL_SPEED_VALUES = {
  Min: 0,
  Max: 5,
};

export const SOUND_RANGE_VALUE = {
  Min: 0,
  Max: 10,
};

export const SOUND_RANGE_MAX_MIN_Y = {
  Max: -20,
  Min: -130,
};

export const SOUND_MOBILE_RANGE_MAX_MIN_Y = {
  Max: -28,
  Min: -139,
};

export const JACK_POTS_TYPE = {
  Club: 1,
  Diamond: 2,
  Heart: 3,
  Spade: 4,
};

export const JACK_POTS_AMOUNT_KEY = {
  Club: 'clubAmount',
  Diamond: 'diamondAmount',
  Heart: 'heartAmount',
  Spade: 'spadeAmount',
};

export const BET_BAR_MARGIN_WEB = 14;
export const BET_BAR_MARGIN_MOBILE = 8;

export const MOBILE_LAST_WIN_TEXT_MARGIN = 10;
export const WEB_LAST_WIN_TEXT_MARGIN = 10;

export const MAX_USER_INACTIVE_STATE_DURATION = 900000;

export const STANDARD_MODE_SPEED = {
  web: 50,
  mobile: 33,
};

export const FAST_MODE_SPEED = {
  web: 55,
  mobile: 36,
};

export const FASTER_MODE_SPEED = {
  web: 60,
  mobile: 40,
};

export const FAKE_DATA = {
  spinId: 15837065,
  balance: 1067747.61,
  maxWin: false,
  winAmount: 1.0,
  odd: 1.0,
  result: {
    matrix: [
      [6, 1, 8],
      [6, 6, 1],
      [4, 4, 10],
      [8, 7, 7],
      [7, 6, 6],
    ],
    additional: {
      wins: [
        { symbol: 1, line: 8, count: 2, lineOdd: 1.0, lineWinAmount: 1.0, lineWinCoinAmount: 1.0 },
      ],
      expandingWild: [0, 0, 0, 0, 0],
    },
  },
  freeSpinCount: 0,
  gambleInfo: null,
  freeBetInfo: null,
  tournamentInfo: null,
  oddMultiplayer: 1.0,
  bonusType: null,
  validation: 10,
};
// {"type":1,"target":"SpinResult","arguments":rage:{}]}
